import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { delay } from 'rxjs/operators';
import * as firebase from 'firebase/app';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'mis-cursos',
  templateUrl: './mis-cursos.component.html',
  styleUrls: ['./mis-cursos.component.css']
})
export class MisCursosComponent implements OnInit {

  loaded = 0; // flag para spinner
  cursosUsuario: any[] = []; // array con los ducumentos de progreso a nombre del usuario;
  display: any[] = []; // array con informacion unida y simplificada del usuario;
  duracion: any[] = []; // duracion total del curso
  cursosInfo: any[] = []; // array con los ducumentos de cursos que haya inscrito el usuario;
  ids: string[] = []; // array de Ids para realizar la busqueda de los cursos inscritos por el usuario


  constructor(
    private afs: AngularFirestore,
    private afAuth: AngularFireAuth,
    private seo: SeoService
  ) { }

  usuario = JSON.parse(localStorage.getItem('user'))

  ngOnInit() {
    this.cargarMisCursos()
  }

  async cargarMisCursos() {
    this.afs.collection('usuariosProgresos').ref.where('usuarioId', '==', this.usuario.uid).get().then(response => {
      response.docs.forEach((doc) => {
        const data = doc.data();
        const idCurso = data['cursoId']
        this.cursosUsuario = this.cursosUsuario.concat(doc.data())
        this.ids = this.ids.concat(idCurso);
      })
    }).then(() => {
      this.cargarInfo();
    }).catch(error => {
      console.log(error);
    })
  }

  cargarInfo() {
    this.afs.collection('cursos').ref.where(firebase.default.firestore.FieldPath.documentId(), 'in', this.ids).get().then((response) => {
      response.docs.forEach((doc) => {
        this.cursosInfo = this.cursosInfo.concat(doc.data())
      })
    }).then(() => {
      // this.calcularProgresos();
      this.loaded = 1;
      this.seo.generateTags({
          title: this.cursosInfo[0].titulo,
          image: this.cursosInfo[0].foto,
          description: this.cursosInfo[0].resumen
      })
    })
  }

  // calcularProgresos() {
  //   for (let index = 0; index < this.cursosUsuario.length; index++) {
  //     const titulo = this.cursosInfo[index].titulo;
  //     const descripcion = this.cursosInfo[index].resumen;
  //     const foto = this.cursosInfo[index].foto;
  //     const instructor = this.cursosInfo[index].instructorNombre;
  //     const empresa = this.cursosInfo[index].nombreEmpresa;
  //     let duracion = 0;
  //     let contador = 0
  //     let porcentajeCompletado = 0;
  //     for (let j = 0; j < this.cursosUsuario[index]['clases'].length; j++) {
  //       duracion += this.cursosUsuario[index]['clases'][j].modulo.duracion
  //       if (this.cursosUsuario[index]['clases'][j].completado == 1) {
  //         contador += 1
  //       }
  //     }
  //     porcentajeCompletado = contador * 100 / this.cursosUsuario[index]['clases'].length
  //     this.display = this.display.concat({
  //       'titulo': titulo,
  //       'foto': foto,
  //       'descripcion': descripcion,
  //       'instructor': instructor,
  //       'empresa': empresa,
  //       'duracion': duracion,
  //       'porcentajeCompletado': porcentajeCompletado
  //     })
  //   }
  //   console.log(this.display)
  //   this.loaded = 1;
  // }
}


